import React from "react";
import { useTranslation } from 'react-i18next';
// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Slide from "@material-ui/core/Slide";
import Despesas from "beaktClinic/views/Financeiro/Despesas";
import ContasPagar from "beaktClinic/views/Financeiro/ContasPagar";
import ContasReceber from "beaktClinic/views/Financeiro/ContasReceber";
import Demonstrativo from "beaktClinic/views/Financeiro/Demonstrativo";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function ControleFinanceiro() {
    const { t } = useTranslation();
    
    const [componente, setcomponente] = React.useState("Demonstrativo");    

    return (
        <div>                                     
            <GridContainer>                                
                <GridItem xs={6} sm={3} md={3}>
                    <center>
                    <Button round color="primary" simple={componente === "Demonstrativo" ? "" : "simple"}
                        onClick={() => setcomponente("Demonstrativo")}>
                        {t("financial.demonstrative")} 
                    </Button>
                    </center>
                </GridItem>
                <GridItem xs={6} sm={3} md={3}>
                    <center>
                    <Button round color="primary" simple={componente === "Contas a Pagar" ? "" : "simple"}
                        onClick={() => setcomponente("Contas a Pagar")}>
                        {t("financial.bill_to_pay")}
                    </Button>
                    </center>
                </GridItem>
                <GridItem xs={6} sm={3} md={3}>
                    <center>
                    <Button round color="primary" simple={componente === "Contas a Receber" ? "" : "simple"}
                        onClick={() => setcomponente("Contas a Receber")}>
                        {t("financial.bill_to_receive")}
                    </Button>
                    </center>
                </GridItem>
                <GridItem xs={6} sm={3} md={3}>
                    <center>
                    <Button round color="primary" simple={componente === "Despesas" ? "" : "simple"}
                        onClick={() => setcomponente("Despesas")}>
                        {t("financial.expense")}
                    </Button>
                    </center>
                </GridItem>
                {componente === "Demonstrativo" &&
                    <Demonstrativo/>}
                {componente === "Contas a Pagar" &&
                    <ContasPagar/>}
                {componente === "Contas a Receber" &&
                    <ContasReceber/>}
                {componente === "Despesas" &&
                    <Despesas/>}
            </GridContainer>            
        </div>
    );
}